<template>
  <div>
    <carousel :perPage="1">
      <slide>
          <div class="padding">
          <p>so I don't really know why I'm writing this, I've never kept a diary,<br>
          I've never really written down my thoughts,<br>
          I've definitely never written a letter,<br>
          and yet now i find myself writing to you,<br>
          even though to be honest I'm not sure who you are<br></p>

          <p>It's hard to explain but i feel like you should be here, and I feel like i should know who you are, the strangest thing is that other people seem to think this too, strangers even.</p>
            <br>
          <p>In the coffee shop this afternoon they said 'on your own today?' . . and I didn't really know what they meant, so i just smiled and did my best to nod and laugh.</p>
            <br>
          <p>Looking at what I've just written doesn't help, I feel like I'm talking nonsense, and i should see someone about it. but really somehow it gives me comfort imagining, imagining something like this, someone like this, someone I could have known. Oska fills my life of course, i would never say we want for anything, and still . . .</p>
            <br>
          <p>Who are you? I can't picture you, I can't describe you, and yet I know I miss you. In my father's final years he developed a form of dementia, an aftereffect of years of spacing they said. His memory was on a loop, he repeated himself over and over and over again, by the end he had almost completely forgotten who I was.</p>
            <br>
          <p>As it got worse I thought it might actually be making things easier for him, but then he would say 'there's something wrong with me, but I don't know what it is', and this unknowing was tearing him up inside, there was a knowledge just out of his grasp, just out of his sight, and he was never going to reach it.</p>
<br>
          <p>sometimes...</p>
          </div>
      </slide>

      <slide>
          <div class="padding">
          <p>when I wake up</p>
          </div>
      </slide>

      <slide>
          <div class="padding">
          <p>I expect someone</p>
          </div>
      </slide>

      <slide>
          <div class="padding">
          <p>to be there beside me</p>
          </div>
      </slide>

      <slide>
          <div class="padding">
          <p>the rooms are too quiet</p>
          </div>
      </slide>

    </carousel>
  </div>
</template>

<script>
export default {

  name: '3',

  data () {
    return {
      title: 'My Father'
    }
  }
}
</script>

<style lang="css" scoped>
</style>
